(function(){
  var d=document, root=d.documentElement;
  if(!('IntersectionObserver' in window))return;
  try{ if(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)return; }catch(e){}
  root.classList.add('fx');
  var SEL='.baip .frow,.baip .supcard,.baip .rcard,.baip .hl,.baip .incl,.baip .demo,.baip .vid,.baipc .pcard,.baisw .scard,.baisw .steps,.baisw .vidframe';
  function reveal(){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('fx-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    var i=0;
    d.querySelectorAll(SEL).forEach(function(el){
      if(el.__fx)return; el.__fx=1;
      el.style.transitionDelay=(Math.min(i,5)*60)+'ms'; i++;
      io.observe(el);
    });
  }
  function glow(){
    d.querySelectorAll('.baip .hl,.baisw .steps,.baip .demo').forEach(function(el){
      if(el.__g)return; el.__g=1;
      el.addEventListener('pointermove',function(ev){
        var r=el.getBoundingClientRect();
        el.style.setProperty('--mx',((ev.clientX-r.left)/r.width*100)+'%');
        el.style.setProperty('--my',((ev.clientY-r.top)/r.height*100)+'%');
      });
    });
  }
  function fmt(n,big){ n=Math.round(n); return big?n.toLocaleString('en-US'):String(n); }
  function run(tn,target,big){
    var dur=1200,t0=null;
    function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1); var e=1-Math.pow(1-p,3); tn.nodeValue=fmt(target*e,big); if(p<1)requestAnimationFrame(step); else tn.nodeValue=fmt(target,big); }
    tn.nodeValue=fmt(0,big); requestAnimationFrame(step);
  }
  function countup(){
    d.querySelectorAll('.baihero .hstats .baix-num, .baix-countup').forEach(function(el){
      if(el.__c)return;
      var tn=el.firstChild; if(!tn||tn.nodeType!==3)return;
      var raw=(tn.nodeValue||'').trim();
      var num=parseFloat(raw.replace(/[^0-9.]/g,''));
      if(isNaN(num)||num<=0)return;
      el.__c=1;
      var big=num>=1000;
      var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ run(tn,num,big); io.disconnect(); }});},{threshold:0.4});
      io.observe(el);
    });
  }
  function chrome(){
    if(d.__chrome)return; d.__chrome=1;
    var bar=d.createElement('div'); bar.className='baifx-prog'; d.body.appendChild(bar);
    var top=d.createElement('button'); top.className='baifx-top'; top.setAttribute('aria-label','Back to top');
    var ar=d.createElement('i'); ar.className='baifx-ar'; top.appendChild(ar);
    d.body.appendChild(top);
    top.addEventListener('click',function(){ window.scrollTo({top:0,behavior:'smooth'}); });
    var hdr=d.getElementById('baihx-root');
    var ticking=false;
    function upd(){
      ticking=false;
      var st=window.pageYOffset||root.scrollTop||0;
      var h=(d.documentElement.scrollHeight-window.innerHeight);
      bar.style.width=(h>0?(st/h*100):0)+'%';
      if(st>10){ if(hdr)hdr.classList.add('is-stuck'); top.classList.add('on'); }
      else{ if(hdr)hdr.classList.remove('is-stuck'); top.classList.remove('on'); }
    }
    window.addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(upd); } },{passive:true});
    upd();
  }
  function uline(){
    d.querySelectorAll('.baix-h2, .pgtitle, .qtitle, .baicol .ctitle').forEach(function(h){
      if(h.__ul)return; h.__ul=1;
      var al='left'; try{ al=getComputedStyle(h).textAlign; }catch(e){}
      var w=d.createElement('div'); w.className='baifx-uline'; w.style.textAlign=al;
      w.innerHTML='<svg width="64" height="4" viewBox="0 0 64 4" aria-hidden="true"><line x1="2" y1="2" x2="62" y2="2"/></svg>';
      if(h.nextSibling){ h.parentNode.insertBefore(w,h.nextSibling); } else { h.parentNode.appendChild(w); }
      var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ w.classList.add('drawn'); io.disconnect(); } });},{threshold:0.6});
      io.observe(w);
    });
  }
  function init(){ try{reveal();glow();countup();chrome();uline();}catch(e){} }
  if(d.readyState!=='loading')init(); else d.addEventListener('DOMContentLoaded',init);
  d.addEventListener('shopify:section:load',init);
})();
